import { GET_BALANCE } from './../constants';
import { handleActions } from "redux-actions"
import { arrayhierarchy } from '../functions/arrays';

export const balances  = handleActions(
  {
    [ GET_BALANCE ]: (state, action) => {
      let dataReturn = {}
      if (action.payload.name ==='Timeout') {
        dataReturn = state
      } else
      if (action.payload.error ) {
        dataReturn = state
      } else {
        let arrResult = arrayhierarchy(action.payload.data, ['AHORRO', 'CUENTA PREMIUM', 'CORRESPONSALIA', 'AHORRO MENORES DE EDAD', 'CERTIFICADOS DE APORTACION', 'AHORRO PROGRAMADO'], 'Tipo')
        // console.log(arrResult)
        dataReturn = arrResult
      }
      return dataReturn
    },
  }, []
)
